class Sharing {
	constructor(type) {
		this._type = type;

		this._entityIds = [];
		this._entities = [];

		this._loaded = false;

		this._selectionIds = [];

		if (isCommunity) {
			this._dialog = Dialog.Popup('availability', this._container = div('availability-popup'), 'left-start').sticky();
		}
		else {
			this._dialog = Dialog.Modal(
				'sharing', this.title, X_LARGE, _("SAVE SHARING"), 
				this._container = div('accordion accordion-flush', null, null, {
					'id': 'sharing-accordion'
				})
			);
			this._dialog.head = div('sharing-headings', this.headings);
		}
	}

	get editOption() {
		return this._type.match(/^(timeline|layer|resources|graphics|goals|pins)$/); 
	}

	get shareOption() {
		return this._type.match(/^(resources|graphics)$/); 
	}

	get title() {
		switch(this._type) {
			case 'timeline': return _("Timeline sharing")
			case 'layer': return _("Layer sharing")
			case 'resources': return _("Resource sharing")
			case 'graphics': return _("Graphic sharing")
			case 'goals': return _("Goal sharing")
			case 'feelings': return _("Feeling sharing")
			case 'pins': return _("Pin sharing")
			default: return _("Oops!!")
		}
	}
	get headings() {
		switch(this._type) {
			case 'timeline': case 'layer': 
				return [
					span('share-option', _("VIEW")),
					span('share-option', _("EDIT"))
				];
			case 'resources': case 'graphics': 
				return [
					span('share-option', _("USE")),
					span('share-option', _("EDIT")),
					span('share-option', _("SHARE"))
				];
			case 'goals': 
				return [
					span('share-option', _("VIEW")),
					span('share-option', _("ADD"))
				];
			case 'feelings': 
				return [
					span('share-option', _("VIEW"))
				];
			case 'pins': 
				return [
					span('share-option', _("VIEW")),
					span('share-option', _("PLACE"))
				];
			default: return [];
		}
	}

	mapOne(id, button, event) {
		this._selectionIds = [id];
		this.open(button || false, event);
	}

	mapSelection(ids, button) {
		this._selectionIds = ids;
		this.open(button || false);
	}

	open(button, event) {
		if (this._selectionIds.length === 0) return;
		this._entities.forEach(e => e.clear());
		if (button) {
			this._dialog.handle(button, event);
		}
		else {
			this._dialog.open(this.save.bind(this)).loading();
		}

		ajg('sharing/' + this._type, [
			'selectionIds=' + encodeURI(this._selectionIds.join(',')),
			'firstTime=' + (this._loaded ? 0 : 1)
		], null, (reply) => {
			let max = this._selectionIds.length;
			if (showError(reply)) return;
			if (reply.allMembers) {
				let all = ShareEntity.fromArray(reply.allMembers, this);
				this._entityIds.push(all.id);
				this._entities.push(all);
				this._container.appendChild(all.elem);

				if (reply.teams && Array.isArray(reply.teams) && reply.teams.length){
					reply.teams.forEach(data => {
						let team = ShareEntity.fromArray(data, this);
						this._entityIds.push(team.id);
						this._entities.push(team);
						this._container.appendChild(team.elem);
					});
				}
			}
			else {
				if (reply.heroes && Array.isArray(reply.heroes)){
					let heroes = new ShareGrp('heroes');
					reply.heroes.forEach(data => {
						let hero = ShareEntity.fromArray(data, this);
						heroes.addRow(hero.elem);
						this._entities.push(hero);
						this._entityIds.push(hero.id);
					});
					this._container.appendChild(heroes.elem);
				}
				if (reply.teams && Array.isArray(reply.teams) && reply.teams.length){
					let teams = new ShareGrp('teams');
					reply.teams.forEach(data => {
						let team = ShareEntity.fromArray(data, this);
						teams.addRow(team.elem);
						this._entities.push(team);
						this._entityIds.push(team.id);
					});
					this._container.appendChild(teams.elem);
				}
				if (reply.communities && Array.isArray(reply.communities)){
					let communities = new ShareGrp('communities');
					reply.communities.forEach(data => {
						let community = ShareEntity.fromArray(data, this);
						communities.addRow(community.elem);
						this._entities.push(community);
						this._entityIds.push(community.id);
					});
					this._container.appendChild(communities.elem);
				}
			}

			if (reply.map && Array.isArray(reply.map) && reply.map.length) {
				reply.map.forEach((m) => {
					let idx = this._entityIds.indexOf(m.shift());
					if (idx != -1) {
						let row = this._entities[idx];
						row.init(max, m.shift(), m.shift(), m.shift());
					}
				}, this);
			}
		});
		
		this._loaded = true;
		if (!button) {
			this._dialog.ready();
		}
	}

	save() {
		let changes = [];
		for (let i = 0; i < this._entities.length; i++) {
			if (this._entities[i].changed) changes.push(this._entities[i].map);
		}
		if (changes.length) {
			ajg('sharing/' + this._type, [
				'selectionIds=' + encodeURI(this._selectionIds.join(',')),
				'changes=' + JSON.stringify(changes)
			], null, (reply) => {
				showError(reply);
			});
		}
	}

	getEntity(id, name, value) {
		let i = this._entityIds.indexOf(id);
		if (i === -1) {
			let entity = new ShareEntity(id, name, value, this._fullAccessOption);
			this._entityIds.push(id);
			this._entities.push(entity);
			return entity;
		}
		else {
			return this._entities[i];
		}
	}

	get changes() {
		let changes = {};
		this._entities.forEach(entity => {
			if (entity.changed) {
				changes[entity.id] = entity.value;
			}
		});
		return changes;
	}
}